module.exports = __webpack_public_path__ + "static/media/carta_22.e4e766f8.jpg";